import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export const Footer = () => (
    <footer data-testid="footer" className="border-t border-white/10 px-6 py-10">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-5 sm:flex-row">
            <div className="flex items-center gap-2.5">
                <Logo size={20} />
                <span className="font-display text-base font-medium tracking-tight text-white">RedeemDeals</span>
            </div>
            <p className="text-center text-xs text-white/35 sm:text-sm">
                © 2026 RedeemDeals — promoting Emergent, the AI app builder.
            </p>
            <div className="flex items-center gap-6 text-xs text-white/35 sm:text-sm">
                <Link to="/privacy" data-testid="footer-link-privacy" className="transition-colors duration-200 hover:text-white">
                    Privacy
                </Link>
                <Link to="/terms" data-testid="footer-link-terms" className="transition-colors duration-200 hover:text-white">
                    Terms
                </Link>
            </div>
        </div>
    </footer>
);
